<div class="surface-ground min-h-screen p-4">
  <share-page-header title="Settings" subtitle="Manage your account settings and preferences">
    <div actions class="flex gap-2">
      <p-button
        label="Refresh"
        icon="pi pi-refresh"
        styleClass="p-button-outlined"
        (onClick)="refreshSettings()"
      ></p-button>
      <p-button
        label="Save All"
        icon="pi pi-save"
        styleClass="p-button-primary"
        (onClick)="saveAllSettings()"
      ></p-button>
    </div>
  </share-page-header>

  <div class="grid">
    <div class="col-12 lg:col-8">
      <share-section-card title="User Profile" icon="pi pi-user">
        <p class="text-600 mb-3">Manage your personal information and account settings</p>
        <app-user-profile></app-user-profile>
      </share-section-card>

      <share-section-card title="User Preferences" icon="pi pi-sliders-h">
        <p class="text-600 mb-3">Customize your application preferences and display settings</p>
        <app-user-preferences></app-user-preferences>
      </share-section-card>

      <share-section-card title="Security Settings" icon="pi pi-shield">
        <p class="text-600 mb-3">Manage your account security and password settings</p>
        <app-password-reset></app-password-reset>
      </share-section-card>

      <share-section-card title="General Settings" icon="pi pi-cog">
        <p class="text-600 mb-3">Configure general application settings and system preferences</p>
        <div class="grid">
          <div class="col-12 md:col-6">
            <div class="setting-item">
              <label class="text-900 font-medium">Theme</label>
              <p-dropdown appendTo="body"
                [options]="themeOptions"
                [(ngModel)]="selectedTheme"
                placeholder="Select Theme"
                class="w-full"
              ></p-dropdown>
            </div>
          </div>
          <div class="col-12 md:col-6">
            <div class="setting-item">
              <label class="text-900 font-medium">Language</label>
              <p-dropdown appendTo="body"
                [options]="languageOptions"
                [(ngModel)]="selectedLanguage"
                placeholder="Select Language"
                class="w-full"
              ></p-dropdown>
            </div>
          </div>
          <div class="col-12">
            <div class="setting-item">
              <label class="text-900 font-medium">Notifications</label>
              <div class="flex flex-column gap-2 mt-2">
                <p-checkbox
                  [(ngModel)]="emailNotifications"
                  [binary]="true"
                  label="Email Notifications"
                ></p-checkbox>
                <p-checkbox
                  [(ngModel)]="pushNotifications"
                  [binary]="true"
                  label="Push Notifications"
                ></p-checkbox>
                <p-checkbox
                  [(ngModel)]="smsNotifications"
                  [binary]="true"
                  label="SMS Notifications"
                ></p-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-content-end mt-4">
          <p-button
            label="Save Settings"
            icon="pi pi-check"
            styleClass="p-button-primary"
            (onClick)="saveGeneralSettings()"
          ></p-button>
        </div>
      </share-section-card>
    </div>

    <div class="col-12 lg:col-4">
      <share-section-card title="Account Summary" icon="pi pi-info-circle" shadow="shadow-1">
        <div class="flex flex-column gap-3">
          <div class="flex align-items-center p-3 surface-100 border-round">
            <div class="flex-1">
              <div class="text-900 font-medium">Profile Status</div>
              <div class="text-600 text-sm">Complete</div>
            </div>
            <p-tag value="Active" severity="success"></p-tag>
          </div>
          <div class="flex align-items-center p-3 surface-100 border-round">
            <div class="flex-1">
              <div class="text-900 font-medium">Security Level</div>
              <div class="text-600 text-sm">Standard</div>
            </div>
            <p-tag value="Secure" severity="info"></p-tag>
          </div>
          <div class="flex align-items-center p-3 surface-100 border-round">
            <div class="flex-1">
              <div class="text-900 font-medium">Preferences</div>
              <div class="text-600 text-sm">Customized</div>
            </div>
            <p-tag value="Set" severity="warning"></p-tag>
          </div>
        </div>
      </share-section-card>

      <share-section-card title="Quick Actions" icon="pi pi-bolt" shadow="shadow-1">
        <div class="flex flex-column gap-2">
          <p-button
            label="Export Settings"
            icon="pi pi-download"
            styleClass="p-button-outlined w-full justify-content-start"
            (onClick)="exportSettings()"
          ></p-button>
          <p-button
            label="Reset Preferences"
            icon="pi pi-refresh"
            styleClass="p-button-outlined w-full justify-content-start"
            (onClick)="resetPreferences()"
          ></p-button>
          <p-button
            label="Change Password"
            icon="pi pi-key"
            styleClass="p-button-outlined w-full justify-content-start"
            (onClick)="changePassword()"
          ></p-button>
          <p-button
            label="View Activity"
            icon="pi pi-history"
            styleClass="p-button-outlined w-full justify-content-start"
            (onClick)="viewActivity()"
          ></p-button>
        </div>
      </share-section-card>
    </div>
  </div>
</div>
